// src/base/constants.js

// ===========================
// 🔹 Account
// ===========================
export const USER_ROLES = {
  ADMIN: "Administrator",
  MEMBER: "Member",
  VIEWER: "Viewer",
};

export const USER_STATUS = {
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  SUSPENDED: "Suspended",
  INVITED: "Invited",
};

export const INVITATION_STATUS = {
  PENDING: "Pending",
  ACCEPTED: "Accepted",
  DECLINED: "Declined",
  REMOVED: "Removed",
};

// ===========================
// 🔹 Project
// ===========================
export const PROJECT_STATUS = {
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  ARCHIVED: "Archived",
  DRAFT: "Draft",
};

export const PROJECT_ROLES = {
  ADMIN: "Administrator",
  MEMBER: "Member",
  VIEWER: "Viewer",
};

// ===========================
// 🔹 Others
// ===========================

export const PERMISSIONS = {
  READ: "read",
  WRITE: "write",
  ADMIN: "admin",
};

export const TASK_STATUS = {
  TODO: "To Do",
  PENDING: "Pending",
  IN_PROGRESS: "In Progress",
  DONE: "Done",
  BLOCKED: "Blocked",
};

// ===========================
// 🔹 Project type
// ===========================

export const PROJECT_TYPE = {
  BUILDING: "Building",
  ROAD: "Road",
  BRIDGE: "Bridge",
  PIPELINE: "Pipeline",
  WATER_TREATMENT: "Water treatment",
  POWER_PLANT: "Power plant",
  INDUSTRIAL_PLANT: "Industrial plant",
  TUNNEL: "Tunnel",
  PORT: "Port",
  DAM: "Dam",
  NETWORK: "Network",
  OTHER: "Other",
};

// ============================================================================
// Secteurs d’activité — constants.js
// ============================================================================
export const ACTIVITY_SECTOR = {
  MAITRISE_OUVRAGE: "Maîtrise d’ouvrage (MOA)",
  MAITRISE_OEUVRE: "Maîtrise d’œuvre (MOE) / Architecture",
  INGENIERIE: "Ingénierie / Bureau d’études",
  CONSTRUCTION: "Entreprise de construction / Générale",
  SOUS_TRAITANCE: "Artisan / Sous-traitant spécialisé",
  FOURNISSEUR: "Fournisseur / Fabricant / Industriel",
  AUTRE: "Autre / Consultant / Indépendant",
};

// Tableau pour DropdownList
export const ACTIVITY_SECTOR_OPTIONS = Object.entries(ACTIVITY_SECTOR).map(
  ([key, label]) => ({ value: key, label })
);

export const COMPANY_SIZE = {
  TPE: "1 à 10 employés",
  PME: "11 à 50 employés",
  MOYENNE: "51 à 250 employés",
  GRANDE: "251 à 1000 employés",
  GROUPE: "+1000 employés",
};

export const COMPANY_SIZE_OPTIONS = Object.entries(COMPANY_SIZE).map(
  ([key, label]) => ({ value: key, label })
);

// ============================================================================
// Analyse de risques — constants.js
// ============================================================================
export const RISKS_CATEGORY = {
  PLANNING: "Planning",
  REGULATORY: "Regulatory",
  TECHNICAL: "Technical",
  RESOURCES: "Resources",
  FINANCIAL: "Financial",
};
export const RISKS_CATEGORY_OPTIONS = Object.entries(RISKS_CATEGORY).map(
  ([key, label]) => ({ value: key, label })
);

export const RISKS_STATUS = {
  OPEN: "Open",
  MITIGATE: "Mitigate",
  CLOSE: "Close",
};
export const RISKS_STATUS_OPTIONS = Object.entries(RISKS_STATUS).map(
  ([key, label]) => ({ value: key, label })
);
export const RISKS_CRITICITY = {
  LOW: "Low",
  MEDIUM: "Medium",
  HIGH: "High",
};
export const RISKS_CRITICITY_OPTIONS = Object.entries(RISKS_CRITICITY).map(
  ([key, label]) => ({ value: key, label })
);

// ============================================================================
// Analyse de risques — constants.js
// ============================================================================



// ============================================================================
// SYSTEM BREAKDOWN TYPES (A / P / F / L)
// ============================================================================

export const BREAKDOWN_TYPES = {
  A: "Activity",
  P: "Product",
  F: "Function",
  L: "Location",
};

export const BREAKDOWN_TYPE_OPTIONS = Object.entries(BREAKDOWN_TYPES).map(
  ([value, label]) => ({ value, label })
);

// ============================================================================
// ENGINEERING DISCIPLINES (TRIGRAMMES UNIQUES)
// ============================================================================

export const DISCIPLINE_TYPES = {
  CIV: "Civil Engineering",
  ARC: "Architecture",
  HYD: "Hydraulic",
  ELE: "Electrical",
  MEC: "Mechanical",
  GEO: "Geotechnical",
  QUA: "Quality / QC",
  HSE: "HSE / Safety",
  BIM: "BIM / Digital Engineering",
};

export const DISCIPLINE_TYPE_OPTIONS = Object.entries(DISCIPLINE_TYPES).map(
  ([value, label]) => ({ value, label })
);




